// Android StaticMethods.generateScheduleMessage: confirmation text when technicians/validate reports active jobs.
// Returns HTML (for $confirmDialog `message`) or null when no known job types are listed.
const JOB_LABELS = {
  appt: ["Appointment", "Appointments"],
  uq: ["Universal Quote", "Universal Quotes"],
  sar: ["Service & Repair", "Service & Repair"],
  mq: ["Universal Quote", "Universal Quotes"],
  rq: ["Replacement Quote", "Replacement Quotes"],
};

export function scheduleMessage(items) {
  const counts = {};
  (items || []).forEach(i => {
    if (JOB_LABELS[i?.job_type]) counts[i.job_type] = (counts[i.job_type] || 0) + 1;
  });
  const lines = Object.keys(JOB_LABELS)
    .filter(k => counts[k])
    .map(k => `• ${counts[k]} ${counts[k] === 1 ? JOB_LABELS[k][0] : JOB_LABELS[k][1]}`);
  if (!lines.length) return null;
  return "You already have work scheduled during this time:<br><br>" + lines.join("<br>")
    + "<br><br>Continuing will add another job to your schedule.<br><br>Do you want to continue?";
}
